export enum TransactionIntent {
  Unknown = 'Unknown',
  NotSure = 'NotSure',
  Sell = 'Sell',
  Trade = 'Trade'
}

export enum LifeCycleState {
  Active = 'Active',
  AppliedToPurchase = 'AppliedToPurchase', // Treat like Active
  Complete = 'Complete',
  Expired = 'Expired',
  Manual = 'NeedsManualAppraisal',
  Rejected = 'Rejected', // Treat like Manual
  Replaced = 'Replaced',
  Scheduled = 'Scheduled' // Treat like Active
}

type AcquisitionVehicle = {
  color: string;
  make: string;
  model: string;
  trim: string;
  year: number;
};

export type TradeInPreviewAcquisition = {
  daysToExpiration: number | null;
  id: string;
  isAlmostExpired: boolean | null;
  lifeCycleState: LifeCycleState;
  maxTradeTaxSavings: number | null;
  offerAmount: number;
  tradeIncentive: number | null;
  transactionIntent: TransactionIntent;
  vehicle: AcquisitionVehicle;
  equity: number;
  lien: {
    tenDayPayoff: {
      amount: number;
    };
  };
};
